<template>
  <transition @enter="handleCardOpen" :css="false">
    <div
      ref="questionCard"
      data-name="question-card-wrapper"
      :class="[$style.wrapper, $style[type]]"
      v-click-outside="outsideClicked"
    >
      <div data-name="icon-wrapper" v-if="icon1" :class="$style['icon-wrapper']">
        <div :class="$style['icon-container-1']">
          <img
            :class="$style.icon"
            :src="icon1"
            :alt="title + ' SVG Icon'"
            :aria-label="title + ' SVG Icon'"
          />
        </div>
        <!-- <div v-if="icon2" :class="[$style['icon-container-2'], $style['icon-container-1']]">
        <img :class="$style.icon" :src="icon2" :alt="title + ' SVG Icon'" :aria-label="title + ' SVG Icon'">
        </div>-->
      </div>

      <div data-name="content-wrapper" :class="$style['content-wrapper']">
        <!-- <h1 :class="$style['content-header']">{{ title }}</h1> -->
        <div :class="$style['answers-container']">
          <div
            v-for="(answer, index) in answers"
            @click="handleAnswerSelectButtonClicked(index)"
            @mouseover="handleAnswerItemMouseOver"
            @mouseleave="handleAnswerItemMouseLeave"
            v-touch:tap="handleAnswerSelectButtonTap"
            :data-index="index"
            data-name="answer-container"
            class="js-answer-container"
            :class="$style['answer-container']"
            :key="index"
          >
            <div
              :data-index="index"
              :class="$style['answer-text']"
              data-name="answer-text"
            >{{ answer }}</div>
            <!-- <div
            :data-index="index"
            data-name="answer-select-button"
            :class="[$style['answer-select-button'],
                {
                  [$style['selected']]: selectedAnswerIndex === index
                }
              ]"
            ></div>-->
          </div>
        </div>
      </div>

      <div data-name="button-wrapper" :class="$style['button-wrapper']">
        <!-- <div
					ref="submitButton"
					:class="[$style['submit-button'], $style['button-container']]"
				>
					<ui-button
						:buttonText="buttonText"
						:buttonAction="Submit"
						v-touch.native="Submit"
					></ui-button>
        </div>-->
        <div
          ref="continueButton"
          :class="[$style['button-container'], $style['continue-button'], {[$style['ios']] : isMobileSafari }]"
        >
          <ui-button
            :class="$style['continue-ui-button']"
            :buttonText="continueButtonText"
            :buttonAction="Continue"
            v-touch.native="Continue"
          ></ui-button>
        </div>
      </div>
      <div
        v-if="type === 'commercial'"
        :class="[$style['note'], {[$style['ios']] : isMobileSafari }]"
      >
        <div :class="$style['noteContent']">{{ info.extra.commercial }}</div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from "vuex";
import UiButton from "./UiButton";
import vClickOutside from "v-click-outside";
import isMobileMixin from "../plugins/isMobileMixin.js";
import tweenSpeedsMixin from "../plugins/tweenSpeedsMixin.js";
import { TweenMax, TimelineMax } from "gsap";

export default {
  name: "question-card",
  mixins: [isMobileMixin, tweenSpeedsMixin],
  components: {
    "ui-button": UiButton
  },
  props: {
    title: {
      type: String,
      required: true
    },
    type: {
      type: String
    },
    icon1: {
      type: String,
      required: true
    },
    icon2: {
      type: String,
      required: false
    },
    answers: {
      type: Array,
      required: true
    },
    buttonText: {
      type: String,
      required: true
    },
    outsideClicked: {
      type: Function,
      required: true
    },
    roomObject: {
      type: Object,
      required: true
    },
    roomIndex: {
      type: Number
    },
    objectIndex: {
      type: Number
    },
    allQuestionsAnswered: {
      type: Boolean
    }
  },
  directives: {
    clickOutside: vClickOutside.directive
  },
  data() {
    return {
      selectedAnswerIndex: null,
      correctAnswerIndex: null,
      completed: null,
      answerEls: null,
      continueButtonText: "Continue",
      isMobileSafari: false
    };
  },
  watch: {
    roomObject(state, oldState) {
      this.handleCardInit();
    },
    allQuestionsAnswered(state, oldState) {
      if (state) {
        this.continueButtonText = "FINISH";
      } else {
        this.continueButtonText = "Continue";
      }
    }
  },
  computed: {
    ...mapGetters({
      info: "content/all"
    })
  },
  mounted() {
    this.handleCardInit();

    this.$bus.$on("room-button-click", this.Continue);

    this.isMobileSafari = this.$browserInfo.os === "iOS";
  },
  methods: {
    handleAnswerItemMouseOver(e) {
      // if (this.completed) {
      // 	return;
      // }
      // let el = e.target;
      // if (el.classList.contains("js-answer-container")) {
      // 	TweenMax.to(el, 0.1, {
      // 		backgroundColor: "#f5fae5"
      // 	});
      // }
    },
    handleAnswerItemMouseLeave(e) {
      if (this.completed) {
        return;
      }
      let el = e.target;

      if (el.classList.contains("js-answer-container")) {
        TweenMax.to(el, 0.1, {
          backgroundColor: "#ffffff"
        });
      }
    },
    handleCardInit: function() {
      this.selectedAnswerIndex = null;
      this.completed = null;
      this.answerEls = document.querySelectorAll(".js-answer-container");
      this.correctAnswerIndex = this.roomObject.correctAnswerIndex;

      if (this.roomObject.completed) {
        // case: question already answered - style accordingly!
        this.completed = true;
        this.selectedAnswerIndex = this.roomObject.selectedIndex;
        let selectedAnswerEl = this.answerEls[this.selectedAnswerIndex];
        let correctAnswerEl = this.answerEls[this.correctAnswerIndex];
        let correct = selectedAnswerEl === correctAnswerEl;

        // // hide submit button
        // TweenMax.set(this.$refs.submitButton, {
        // 	opacity: 0,
        // 	pointerEvents: "none"
        // });

        // // show continue button
        // TweenMax.set(this.$refs.continueButton, {
        // 	opacity: 1,
        // 	pointerEvents: "auto"
        // });

        // for (let index = 0; index < this.answerEls.length; index++) {
        // 	let el = this.answerEls[index];
        // 	if (index === this.correctAnswerIndex) {
        // 		// highlight correct answer
        // 		TweenMax.set(correctAnswerEl, {
        // 			backgroundColor: "#6ebe46"
        // 		});
        // 	} else if (index === this.selectedAnswerIndex && !correct) {
        // 		// if user wasn't correct - highlight the incorrect answer
        // 		TweenMax.set(selectedAnswerEl, {
        // 			backgroundColor: "#f4583f"
        // 		});
        // 	} else {
        // 		TweenMax.set(this.answerEls[index], {
        // 			backgroundColor: "white"
        // 		});
        // 	}
        // }
      } else {
        // case:  question not answered - set default styling
        this.completed = false;

        // // show submit button
        // TweenMax.set(this.$refs.submitButton, {
        // 	opacity: 0.3,
        // 	pointerEvents: "auto"
        // });

        // // hide continue button
        // TweenMax.set(this.$refs.continueButton, {
        // 	opacity: 0,
        // 	pointerEvents: "none"
        // });

        // set background on answer els
        // for (
        // 	let answerIdx = 0;
        // 	answerIdx < this.answerEls.length;
        // 	answerIdx++
        // ) {
        // 	TweenMax.set(this.answerEls[answerIdx], {
        // 		backgroundColor: "white"
        // 	});
        // }
      }
    },
    handleCardOpen: function() {
      if (this.isMobile) {
        TweenMax.fromTo(
          this.$refs.questionCard,
          this.tweenSpeeds.dur.cardShow,
          {
            // opacity: 0,
            y: "100%",
            ease: this.tweenSpeeds.ease.global
          },
          {
            // opacity: 1,
            y: "0%",
            ease: this.tweenSpeeds.ease.global
          }
        );
      } else {
        TweenMax.to(this.$refs.questionCard, this.tweenSpeeds.dur.cardShow, {
          right: 0,
          ease: this.tweenSpeeds.ease.global
          // onStart: () => {
          //   let els = document.querySelectorAll('.room-button-component');
          //   console.log('els:  ', els);
          //   if(els.length !== 0) {

          //     for(let i = 0; i < els.length; i++) {
          //       els[i].classList.add('hide-room-button');
          //     }
          //   }
          // },
          // onComplete: () => {
          //   let els = document.querySelectorAll('.room-button-component');
          //   console.log('els:  ', els);
          //   if(els.length !== 0) {

          //     for(let i = 0; i < els.length; i++) {
          //       els[i].classList.add('hide-room-button');
          //     }
          //   }
          // },
        });
      }

      TweenMax.set(this.$refs.questionCard, {
        pointerEvents: "inherit"
      });
    },
    handleCardClose: function(dur) {
      let speed = dur ? dur : this.tweenSpeeds.dur.cardShow;

      if (this.isMobile) {
        TweenMax.fromTo(
          this.$refs.questionCard,
          speed,
          {
            // opacity: 1,
            y: "0%",
            ease: this.tweenSpeeds.ease.global
          },
          {
            // opacity: 0,
            y: "100%",
            ease: this.tweenSpeeds.ease.global
          }
        );
      } else {
        TweenMax.to(this.$refs.questionCard, speed, {
          right: "-100%",
          ease: this.tweenSpeeds.ease.global
        });
      }

      TweenMax.set(this.$refs.questionCard, {
        pointerEvents: "none"
      });
    },

    handleAnswerSelectButtonTap(e) {
      let index = null;
      switch (e.target.dataset.name) {
        case "answer-container":
          let text = e.target.querySelector('[data-name="answer-text"]');
          if (text) {
            index = text.dataset.index;
          }
          break;
        default:
          index = e.target.dataset.index;
      }

      if (index !== null) {
        this.handleAnswerSelectButtonClicked(parseInt(index));
      }
    },
    handleAnswerSelectButtonClicked(indexClicked) {
      if (!this.completed) {
        this.selectedAnswerIndex = indexClicked;

        TweenMax.to(this.$refs.submitButton, 0.5, {
          opacity: 1
        });
      }
      // console.log('index clicked:  ', indexClicked)
    },
    Continue() {
      if (this.allQuestionsAnswered) {
        this.$emit("finishClicked");
      } else {
        this.Submit();
        this.$emit("continueClicked");
      }
    },
    Submit() {
      // if (this.selectedAnswerIndex === null) {
      // 	return;
      // }

      // let isCorrect =
      // this.selectedAnswerIndex === this.roomObject.correctAnswerIndex;
      let isCorrect = true;
      this.completed = true;

      // this.roomObject.completed = true;
      this.roomObject.status = isCorrect
        ? "answeredCorrect"
        : "answeredIncorrect";

      if (
        !this.$store.getters.getQuestionByIds(
          this.roomObject.roomIndex,
          this.roomObject.questionIndex
        ).completed
      ) {
        this.$store.dispatch("completeObject", {
          roomIndex: this.roomObject.roomIndex,
          objectIndex: this.roomObject.questionIndex,
          selectedIndex: this.roomObject.correctAnswerIndex,
          correctIndex: this.roomObject.correctAnswerIndex,
          isCorrect
        });
      }

      this.$emit("submitClicked", this.roomObject);

      // if (isCorrect) {
      // 	// alert('correct answer')
      // 	this.handleSubmitTweens(
      // 		true,
      // 		this.selectedAnswerIndex,
      // 		this.roomObject.correctAnswerIndex
      // 	);
      // } else {
      // 	// alert('incorrect answer')
      // 	this.handleSubmitTweens(
      // 		false,
      // 		this.selectedAnswerIndex,
      // 		this.roomObject.correctAnswerIndex
      // 	);
      // }
    },
    handleSubmitTweens(correct, selectedIndex, correctIndex) {
      let submitButtonEl = this.$refs.submitButton;
      let continueButtonEl = this.$refs.continueButton;
      let correctAnswerEl = this.answerEls[correctIndex];
      let selectedAnswerEl = this.answerEls[selectedIndex];

      // debugger;

      this.handleSubmitButtonTween(submitButtonEl);

      this.handleContinueButtonTween(continueButtonEl);

      this.handleCorrectAnswerRevealTween(correctAnswerEl);

      // if the answer is wrong, animate incorrect answer
      if (!correct) {
        this.handleIncorrectAnswerRevealTween(selectedAnswerEl);
      }
    },
    handleSubmitButtonTween(submitButtonEl) {
      // fade submit button out
      TweenMax.fromTo(
        submitButtonEl,
        0.5,
        {
          opacity: 1
        },
        {
          opacity: 0,
          onStart: () => {
            TweenMax.set(submitButtonEl, { pointerEvents: "none" });
          }
        }
      );
    },
    handleContinueButtonTween(continueButtonEl) {
      // fade continue button in
      TweenMax.fromTo(
        continueButtonEl,
        0.5,
        {
          opacity: 0
        },
        {
          opacity: 1,
          delay: this.tweenSpeeds.dur.continueButtonDelay,
          onComplete: () => {
            TweenMax.set(continueButtonEl, {
              pointerEvents: "auto"
            });
          }
        }
      );
    },
    handleCorrectAnswerRevealTween(correctAnswerEl) {
      // animate correct answer
      TweenMax.to(correctAnswerEl, 0.5, {
        backgroundColor: "#6ebe46"
      });
    },
    handleIncorrectAnswerRevealTween(selectedAnswerEl) {
      TweenMax.to(selectedAnswerEl, 0.5, {
        backgroundColor: "#f4583f"
      });
    }
  }
};
</script>

<style lang='scss' module>
@import "../assets/css/globals.scss";

* {
  // outline: 1px solid red;
}

.wrapper {
  z-index: 500;
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  left: 0;

  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;

  // margin-left: auto;
  // margin-right: auto;
  background-color: white;

  width: 100%;
  height: 100vh;
  // max-width: 600px;

  // border-radius: 0px;

  color: white;

  box-shadow: 0px 2px 30px -1px rgba(0, 0, 0, 0.25);

  opacity: 1;

  pointer-events: none;

  @include large {
    right: -100%;
    top: 0;
    left: auto;

    justify-content: space-between;

    height: 100vh;
    width: 40%;

    // border-radius: 0;

    opacity: 1;

    box-shadow: none;
  }

  @include nateLarge {
    width: 30%;
  }
}

.content-wrapper {
  width: 100%;

  margin: 5px;
  color: black;

  box-sizing: border-box;

  @include large {
    margin: 30px;
  }
}

.content-header {
  font-size: 20px;

  padding-left: 30px;
  padding-right: 30px;

  @include large {
    font-size: 22px;
  }
}

.icon-wrapper {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  margin-top: 30px;
  padding-right: 30px;
  padding-bottom: 0px;
  padding-left: 30px;

  height: 100px;
  width: 100%;

  @include nateLarge {
    height: 130px;
  }
}

@keyframes iconFadeAnim {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.icon-container-1 {
  position: absolute;
  top: 50%;
  left: 50%;

  display: flex;
  justify-content: center;
  align-items: center;

  width: 70px;
  height: 70px;

  border-radius: 50%;
  background-color: rgba($mantis, 0.1);
  transform: translateX(-50%) translateY(-50%);

  & img {
    width: 70px;
    height: 70px;
  }

  @include large {
    width: 70px;
    height: 70px;

    & img {
      width: 70px;
      height: 70px;
    }
  }

  @include nateLarge {
    width: 150px;
    height: 150px;

    & img {
      width: 150px;
      height: 150px;
    }
  }
}

.icon-container-2 {
  background-color: rgba($mantis, 0) !important;

  animation-name: iconFadeAnim;
  animation-duration: 1s;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  animation-timing-function: ease-in-out;
}

.button-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;

  width: 100%;
  height: 75px;

  // padding: 30px;

  // border-top: 2px solid RGBA(52, 108, 172, 0.05);

  font-weight: bold;

  @include large {
    width: 100%;

    padding-top: 30px;
    padding-bottom: 30px;

    margin-top: auto;
  }
}

.button-container {
  position: absolute;
  bottom: 40px;
  left: 50%;
  display: block;
  width: 220px;
  height: 50px;

  transform: translateX(-50%);

  .commercial & {
    bottom: 140px;

    &.ios {
      bottom: 210px;
    }
  }
}

.answers-container {
  width: 100%;

  font-size: 15px;

  @include large {
    font-size: 16px;
  }
}

.submit-button {
  transform: translateX(50%);

  @include large {
    transform: translateX(-50%);
  }
}

.continue-button {
  opacity: 1;
  // display: none;
  pointer-events: auto;
  cursor: pointer;
}

.continue-ui-button {
  background-color: green;
  &:before {
    background-color: darken(green, 15%);
  }
}

.answer-container {
  display: flex;
  justify-content: space-between;
  align-items: center;

  padding-top: 20px;
  padding-right: 30px;
  padding-bottom: 20px;
  padding-left: 30px;

  border-top: 1px solid rgba(0, 0, 0, 0.2);

  cursor: pointer;
}

.answer-container:last-of-type {
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
}

.answer-text {
  width: 100%;

  pointer-events: none;

  @include large {
    font-size: 18px;
    line-height: 28px;
  }

  @include xxlarge {
    font-size: 24px;
    line-height: 36px;
  }
}

.answer-select-button {
  height: 25px;
  width: 25px;

  border-radius: 50%;

  background-color: rgba(0, 0, 0, 0.2);
}

.selected {
  background-color: RGBA(246, 145, 58, 1);
}

// .js-answer-container {
//   transition: all 0.2s ease-out;
// }

// .js-answer-container:hover {
//   background-color: #f5fae5;
// }

.note {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 20px;

  color: white;
  font-weight: bold;
  background-color: #f47a3f;
  // border-top: 1px solid rgba(0, 0, 0, 0.2);

  box-sizing: border-box;

  @include large {
    padding: 30px;
    position: static;
  }
}

.note-content {
  padding-bottom: 0;
  border-bottom: 0;
  .ios & {
    padding-bottom: 70px;
  }

  font-size: 0.825em;
  line-height: 1.3;
  // color: rgba(black, 0.75);
  color: white;
  text-shadow: 1px 1px 2px rgba(0,0,0,0.3);

  @include large {
    font-size: 1em;
    line-height: 1.4;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/QuestionCard.vue